import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Img from 'react-image';
import { rem } from 'polished';
import playImg from './playImg.png';
import { translate } from '../../../Utils';
import imgPlaceHolder from './dejmark-logo.svg';

const StyledImage = styled(Img)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${({ theme }) => theme.media.m`
  width: ${rem(400)};
`};
  height: ${rem(250)};
  transition: transform 0.5s;
  &:hover {
    transform: scale(1.1);
  }
`;

const PlayImage = styled(Img)`
  width: ${rem(80)};
  position: absolute;
  opacity: 0.5;
  z-index: 0;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => theme.media.m`
  width: ${rem(400)};
`};
  overflow: hidden;
  position: relative;
  cursor: pointer;
`;

const Title = styled.div`
  color: ${props => props.color && props.color};
  font-size: ${rem(16)};
  margin-top: ${rem(4)};
  font-weight: 700;
  z-index: 2;
  &:hover {
    text-decoration: underline;
  }
`;

const Perex = styled.div`
  color: ${props => props.color && props.color};
  z-index: 2;
  margin-top: ${rem(4)};
  font-weight: 200;
  max-width: ${rem(380)};
  &:hover {
    text-decoration: underline;
  }
`;

// const ReadMore = styled.div`
//   position: absolute;
//   color: ${props => props.color && props.color};
//   right: 30px;
//   bottom: 10px;
//   font-size: 24px;
//   font-weight: bold;
//   &:hover {
//     text-decoration: underline;
//   }
// `;

// const TitleWrapper = styled.div`
//   position: absolute;
//   width: ${rem(500)};
//   top: 0;
//   bottom: 0;
//   background: rgba(216, 216, 216, 0.8);
//   border-bottom: 1px solid #fff;
//   height: ${rem(170)};
// `;

const ImageWrapper = styled.div`
  max-height: ${rem(300)};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${({ theme }) => theme.media.m`
  width: ${rem(400)};

`};
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class ArticleCard extends React.Component {
  render() {
    const { video_label, name, perex, thumbnail, color, appLang } = this.props;

    return (
      <Wrapper>
        {/* <TitleWrapper /> */}

        <ImageWrapper>
          {video_label && <PlayImage src={playImg} />}
          {thumbnail && (
            <StyledImage
              src={
                thumbnail && thumbnail.fullPath
                  ? `${baseURL}/images/500x0/${thumbnail.fullPath}`
                  : imgPlaceHolder
              }
            />
          )}
          {/* <ReadMore color={color}>{__('Čítať viac')}</ReadMore> */}
        </ImageWrapper>
        <Title color={color}>
          {translate(appLang, name.translations, name.value)}
        </Title>
        <Perex color={color}>
          {translate(appLang, perex.translations, perex.value)}
        </Perex>
      </Wrapper>
    );
  }
}

ArticleCard.propTypes = {
  name: PropTypes.shape({
    value: PropTypes.string,
    translations: PropTypes.arrayOf(
      PropTypes.shape({
        lang: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  perex: PropTypes.shape({
    value: PropTypes.string,
    translations: PropTypes.arrayOf(
      PropTypes.shape({
        lang: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  text: PropTypes.shape({
    value: PropTypes.string,
    translations: PropTypes.arrayOf(
      PropTypes.shape({
        lang: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  color: PropTypes.string,
  thumbnail: PropTypes.shape({
    fullPath: PropTypes.string,
  }),
  video_label: PropTypes.bool,
  firm: PropTypes.string,
};

ArticleCard.defaultProps = {
  name: null,
  perex: null,
  text: null,
  thumbnail: null,
  video_label: false,
  firm: 'SK',
  color: 'black',
};

export default ArticleCard;



// WEBPACK FOOTER //
// ./src/Components/Article/ArticleCard/index.jsx